import { Client } from 'colyseus.js';
import { getColyseusEndpoint } from '@/config/online';

let singletonClient: Client | null = null;

export function getOnlineClient(): Client {
  if (!singletonClient) {
    singletonClient = new Client(getColyseusEndpoint());
  }
  return singletonClient;
}

export function resetOnlineClient(): void {
  singletonClient = null;
}

